/* eslint-disable no-param-reassign */
import { useContext, useState, useEffect } from 'react';
import { GlobalContextType, LoadingContextType } from '../models/Context';
import GeneralContext from '../context/GeneralActions';
import { fetchAllContacts, fetchAllLinks } from '../helpers/links';
import { LinkObject } from '../models/Links';
import LoadingContext from '../context/LoadingContext';
import { RequestContacts } from '../models/Forms';
import useLinksList from '../stores/links/useLinksList';

interface UseLinksProps {
  abortLinks: any;
}

const useLinks = ({ abortLinks }: UseLinksProps) => {
  const { linksList, updateLinksList } = useLinksList();
  const { GlobalContext } = useContext(GeneralContext) as GlobalContextType;
  const { setIsLoading } = useContext(LoadingContext) as LoadingContextType;
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [count, setCount] = useState(0);

  const [contacts, setContacts] = useState<RequestContacts[]>([]);

  const refreshLinks = () => {
    abortLinks.current = new AbortController();
    setLoading(true);
    setIsLoading({ loading: true });
    fetchAllLinks(
      GlobalContext.links.order,
      GlobalContext.links.page,
      GlobalContext.links.page_size,
      `${GlobalContext.links.query_filters}${GlobalContext.links.search_filter}`,
      abortLinks.current.signal,
    )
      .then(resp => {
        setCount(resp.count);
        updateLinksList(resp.results);
        setLoading(false);
        setIsLoading({ loading: false });
        if (error) setError(false);
      })
      .catch(err => {
        if (err) {
          setError(true);
          setLoading(false);
          setIsLoading({ loading: false });
        }
        updateLinksList([]);
      });
  };

  const refreshContacts = (ids: number[]) => {
    fetchAllContacts(ids).then(resp => setContacts(resp));
  };

  useEffect(() => {
    if (linksList.length === 0) return;
    const ids = linksList.map(link => link.id);
    refreshContacts(ids);
  }, [linksList]);

  return {
    links: linksList,
    loading,
    error,
    refreshLinks,
    count,
    contacts,
  };
};

export default useLinks;
